var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.40271,
    width: 37.2315,
    height: 35,
    rx: 17.5,
    fill: "#D6E6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12V10H22.5V12L21 12.5V15.5L24.5 22H15L18.5 15.5V12.5L17.5 12Z",
    fill: "#F8FBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4513 22.8025L21.8253 16.8782C21.5572 16.563 21.4231 16.1849 21.4231 15.7437V12.7815C22.1605 12.7815 22.7639 12.2143 22.7639 11.521V10.2605C22.7639 9.56723 22.1605 9 21.4231 9H17.4004C16.663 9 16.0596 9.56723 16.0596 10.2605V11.521C16.0596 12.2143 16.663 12.7815 17.4004 12.7815V15.7437C17.4004 16.1218 17.2664 16.5 16.9982 16.8782L12.3722 22.8025C12.2381 23.1176 12.104 23.4958 12.104 23.937V24.7563C12.104 25.8277 12.9756 26.6471 14.1153 26.6471H24.8423C25.982 26.6471 26.8536 25.8277 26.8536 24.7563V23.937C26.8536 23.4958 26.7195 23.1176 26.4513 22.8025ZM18.1379 17.5714C18.5402 17.0042 18.8084 16.3739 18.8084 15.7437V12.7815C18.8084 12.0882 18.205 11.521 17.4675 11.521V10.2605H21.4901V11.521C20.7526 11.521 20.1492 12.0882 20.1492 12.7815V15.7437C20.1492 16.437 20.3504 17.0672 20.8197 17.5714L23.9037 21.605H15.0539L18.1379 17.5714Z",
    fill: "#1D64C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMedicine);
export default __webpack_public_path__ + "static/media/addMedicine@.c03265aa492e9d9648ee04ffbb4d3b5c.svg";
export { ForwardRef as ReactComponent };